import script from "./Photes.vue?vue&type=script&setup=true&lang=js"
export * from "./Photes.vue?vue&type=script&setup=true&lang=js"

import "./Photes.vue?vue&type=style&index=0&id=7ddcddfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ddcddfe"]])

export default __exports__